const map = {
	"./i18n.de-CH.json": [
		52607,
		[
			607
		]
	],
	"./i18n.es-ES.json": [
		47209,
		[
			209
		]
	],
	"./i18n.fr-BE.json": [
		12868,
		[
			868
		]
	],
	"./i18n.fr-CH.json": [
		50286,
		[
			286
		]
	],
	"./i18n.json": [
		31724,
		[
			724
		]
	],
	"./i18n.nl-BE.json": [
		41910,
		[
			910
		]
	],
	"./i18n.pt-PT.json": [
		38389,
		[
			389
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 51117;
module.exports = webpackAsyncContext;